module.exports = __webpack_public_path__ + "potli-1b9c5071abc9e692d895.jpeg";